import { MetaType, TopicMap } from "../types"
import {
  actionCreatorGuard,
  reducerGuard,
  reducerActions,
  getArrayReducerGuard
} from "../reducers"

export const kind = "snap_courses"

export type SnapCourse = {
  kind: typeof kind
  version: number
  name: string
  topics: TopicMap
  published: boolean
  meta: MetaType
}

export const reducerAction = {
  meta: actionCreatorGuard<SnapCourse, MetaType>("meta", kind),
  topics: actionCreatorGuard<SnapCourse, TopicMap>("topics", kind),
  published: actionCreatorGuard<SnapCourse, boolean>("published", kind),
  name: actionCreatorGuard<SnapCourse, string>("name", kind)
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in keyof Omit<
    SnapCourse,
    "kind" | "version"
  >]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const snapCourseAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const snapCourseReducer = reducerGuard<SnapCourse>(kind)
  .case(...reducerAction.meta)
  .case(...reducerAction.topics)
  .case(...reducerAction.published)
  .case(...reducerAction.name)
  .build()
